import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useParams } from 'react-router-dom'

// components
import { CButton } from '@coreui/react-pro'
import AppCard from '../../components/AppCard'
import AppCardHeader from 'src/components/card/AppCardHeader'
import AppDetails from 'src/components/details/contact-details/AppDetails';

// helpers
import Axios from '../../helpers/axios'
import useToastMessage from 'src/helpers/toast-message'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

const ContactDetails = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const params = useParams()
  const { id } = params
  const { showError } = useToastMessage();

  const [contactDetail, setContactDetail] = useState('')

  const handleCardHeaderButton = () => {
    navigate(`/contacts/edit/${id}`)
  }

  useEffect(() => {
    fetchDetailUser()
  }, [id]);

  const fetchDetailUser = () => {
    dispatch({
      type: 'SET_IS_LOADING',
      isLoading: true
    })
    Axios({
      method: "get",
      url: `/api/whatsapp/v1/contact/id/${id}`,
    })
      .then(({ data }) => {
        if (data) {
          setContactDetail(data?.value)
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      })
      .finally(() => {
        dispatch({
          type: 'SET_IS_LOADING',
          isLoading: false
        })
      })
  }

  return (
    <>
      <div className='d-grid gap-2 d-md-flex justify-content-md-start mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/contacts')}>
          Back
        </CButton>
      </div>
      <AppCard 
        className='mb-4'
        headerTitle={
          <AppCardHeader
            headerTitle={<h4>Contact Details</h4>}
            headerButton="Edit"
            handleCardHeaderButton={handleCardHeaderButton}
          />
        }
        bodyContent={
          <AppDetails
            contactDetails={contactDetail}
          />
        }
      />
    </>
  )
}

export default ContactDetails